export default __webpack_public_path__ + "static/media/mysticalbane3.983e6e4f.png";